import { render, staticRenderFns } from "./DrugOrdersInboxRightBar.vue?vue&type=template&id=60c5ab1c&"
import script from "./DrugOrdersInboxRightBar.vue?vue&type=script&lang=js&"
export * from "./DrugOrdersInboxRightBar.vue?vue&type=script&lang=js&"
import style0 from "./DrugOrdersInboxRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports